export default {
  palette: {
    purple: '#504388',
    //menu
    themePicker: "#050404",
    // header
    headerText: '#050404',

    menuActive: '#504388',
    menuText: 'rgba(0, 0, 0, 0.3)',
    menuLine: 'rgba(80, 67, 136, 0.66)',
    menuIcons: '#F4F4F4',
    //feed
    cardColor: '##F4F4F4',
    cardText: '#050404',
    actionText: 'rgba(0, 0, 0, 0.7)',
    bodyText: '#050404',
    footerText: '#050404',
    //navigation
    navigation: '#504388',


    purpleDark: '#261753',
    gray: '#B6BBC4',
    orange: '#EB830E',
    orangeDark: '#C16D0F',
    brown: '#B58B52',
    black: '#050404',
    white: '#F4F4F4',
  },
}
